<template lang="pug">
  header#header(:class="{ white: whiteHeader}")
    .grid-noBottom
      .col-6
        router-link.home(:to="{ name: 'home'}" @click.native="setHomeState")
          h2.h-l.lh-8
            | California <br/>
            | African American <br/>
            | Museum
          .header-logo
            visual(v-if="!whiteHeader" image="/static/logos/caam_logo_white.svg")
            visual(v-if="whiteHeader" image="/static/logos/caam_logo.svg")
    nav
      button.h-l.ag.bold.menu-button(
        @click="showNav"
        :class="{ active: menu, white: whiteHeader}"
        :aria-label="ariaMenu"
      )
        | {{ menuText }}
      .hamburger(@click="showNav" :class="{ active: menu }" v-if="!menu")
        visual(v-if="!whiteHeader" image="/static/icons/hamburger.svg")
        visual(v-if="whiteHeader" image="/static/icons/hamburger_black.svg")
      .x(@click="showNav" :class="{ active: menu }" v-if="menu")
        visual(v-if="whiteHeader" image="/static/icons/x_out_white.svg")
        visual(v-if="!whiteHeader" image="/static/icons/x_out_black.svg")
      button.icon(
        @click="showSearchOnly"
        v-if="searchIcon()"
        aria-label="Open search by pressing enter or clicking."
        role="button"
      )
        visual(image="/static/icons/search_white.svg", width="3rem")
      button.icon(
        href=""
        @click="showSearchOnly"
        v-if="!searchIcon()"
        aria-label="open search"
        role="button"
      )
        visual(image="/static/icons/search_black.svg", width="3rem")
      ul(:class="{ active: menu, white: !whiteHeader, black: whiteHeader}" v-if='!loading')
        li(v-for="item in navElements" v-if="!searchOnly")
          router-link.bold.l-l(
            :to="{ name: item.uid}",
            @mouseover.native="showChildren(item.uid, $event)"
            :class="item.uid + '-link'"
          )
            | {{ item.title }}
          ul.d-o(v-if="active === item.uid")
            li(v-for="child in item.children")
              router-link.bold.l-sm(
                v-if="(item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                | {{ child.title.toLowerCase() }}
              router-link.bold.l-sm(
                v-if="item.uid === 'exhibitions' && formatRoute(child.uid) !== 'current'"
                :to="{name: `${item.uid}-overview`, params: { year: formatRoute(child.uid) }}"
              )
                | {{ child.title.toLowerCase() }}
              router-link.bold.l-sm(
                v-if="item.uid === 'exhibitions' && formatRoute(child.uid) === 'current'"
                :to="{name: `${item.uid}`}"
              )
                | {{ child.title.toLowerCase() }}
              router-link.bold.l-sm(
                v-if="item.uid === 'programs'"
                :to="{name: `${item.uid}-overview`, params: { category: formatRoute(child.uid) }}"
              )
                | {{ formatProgramChildren(child.title.toLowerCase()) }}
              router-link.bold.l-sm(
                v-if="item.uid === 'learn' && child.uid === '600state'"
                :to="{name: 'blog'}"
              )
                | {{ child.title.toLowerCase() }}
              router-link.bold.l-sm(
                v-else-if="item.uid === 'learn' && child.uid !== '600state'"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                | {{ child.title.toLowerCase() }}
              router-link.bold.l-sm(
                v-else-if="(item.uid === 'about' && child.uid !== 'subscribe')"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                | {{ child.title.toLowerCase() }}
              h3(v-else-if="(item.uid === 'about' && child.uid === 'subscribe')" @click="subscribe")
                | {{ child.title.toLowerCase() }}
        li
          transition(name="fade")
            ul.search(v-if="search" :class="{ black: whiteHeader}")
              li
                form(onsubmit="return false")
                  label.dn(for="searchterm") Search Query
                  input(type="text" v-model="query" @keyup.enter="submit" name="searchterm" title="Search Query")
              li
                h4(@click="submit" role="button" aria-label="Submit search.")
                  | just ask.
    .banner(v-if="bannerText.length")
      h2(v-html="bannerText")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
export default {
  name: 'top-nav',
  mixins: [DataMixin],

  data () {
    return {
      active: null,
      bannerLoaded: false,
      bannerText: '',
      menu: false,
      menuText: 'menu',
      query: null,
      search: false,
      searchOnly: false,
      whiteHeader: false
    }
  },

  props: ['headerColor'],

  created () {
    this.requestData('root', 'root')
    this.getBannerData()
    // this.whiteHeader = this.$ls.get('whiteHeader')
    this.whiteHeader = window._caam_whiteHeader
    // this.$ls.set('menu', false)
    window._caam_menu = false
    this.whiteHeader = this.headerColor === 'white'
  },

  computed: {
    ariaMenu () {
      return this.menuText === 'menu' ? 'open menu' : 'close menu'
    },

    activeElement () {
      return document.activeElement
    },

    navElements () {
      if (this.loadedData.root) {
        return this.loadedData.root.map((o) => {
          // TEMP Remove 2 cateories from programs
          if (o.uid === 'programs') {
            const newChildren = o.children.filter((c) => {
              return c.uid !== 'Now!' && c.uid !== 'Special Events'
            })
            delete o.children
            o.children = newChildren
          }

          return o
        })
      }
      return []
    }
  },

  mounted () {
    document.addEventListener('keyup', this.handleKeys)
  },

  destroyed () {
    document.removeEventListener('keyup', this.handleKeys)
  },

  methods: {
    getBannerData: function () {
      this.bannerLoaded = false
      this.get('https://caamuseum.org/api/banner', response => {
        this.bannerLoaded = true
        this.bannerText = response.data[0]
      })
      this.bannerLoaded = true
    },

    handleKeys (e) {
      const classes = e.target.className
      if (e.key === 'Tab') {
        if (classes === 'menu-button') {
          this.showNav()
        } else if (classes.includes('visit-link')) {
          this.showChildren('visit')
        } else if (classes.includes('exhibitions-link')) {
          this.showChildren('exhibitions')
        } else if (classes.includes('programs-link')) {
          this.showChildren('programs')
        } else if (classes.includes('collection-link')) {
          this.showChildren('collection')
        } else if (classes.includes('library-link')) {
          this.showChildren('library')
        } else if (classes.includes('learn-link')) {
          this.showChildren('learn')
        } else if (classes.includes('support-link')) {
          this.showChildren('support')
        } else if (classes.includes('about-link')) {
          this.showChildren('about')
        }
      }
    },

    showNav () {
      // this.menu = !this.$ls.get('menu')
      this.menu = !window._caam_menu
      this.menuText = this.menu ? 'close' : 'menu'
      this.searchOnly = false
      this.search = false
      // this.$ls.set('menu', this.menu)
      window._caam_menu = this.menu
    },

    showSearchOnly () {
      // if (!this.$ls.get('menu')) {
      //   this.showNav()
      // }
      if (!window._caam_menu) {
        this.showNav()
      }

      this.searchOnly = true
      this.search = true
    },

    showChildren (uid, event) {
      // event.preventDefault()
      window._caam_active = uid
      this.active = window._caam_active
      // this.$ls.set('active', uid)
      // this.active = this.$ls.get('active')
    },

    setHomeState () {
      window._caam_introBG = false
      window._caam_intro = false
      // this.$ls.set('introBG', false)
      // this.$ls.set('intro', false)
    },

    submit () {
      this.$router.push({name: 'search', query: {query: this.query}})
    },

    subscribe () {
      this.$emit('update:subscribe', true)
    },

    searchIcon () {
      return (this.whiteHeader && this.menu) || (!this.whiteHeader && !this.menu)
    },

    formatRoute (item) {
      return (item.replace(/ |'/g, '-').toLowerCase()).split('!').join('')
    },

    formatProgramChildren (item) {
      if (item === 'kids teens and families') {
        return 'kids, teens and families'
      } else if (item === "can't stop won't stop!") {
        return "can't stop, won't stop!"
      } else if (item === 'concerts performances and screenings') {
        return 'concerts, performances and screenings'
      } else {
        return item
      }
    }
  }
}

</script>

<style lang="sass">
@import '../styles/_mixins'
@import '../styles/_variables'
#header
  @include no-select
  background-color: #000
  color: white
  position: fixed
  top: 0
  width: 100vW
  z-index: 9999
  @include respond-to(xs)
    height: 5rem
  &.white
    background-color: #FFF
    color: #000
  h2
    padding-top: 2rem
    padding-bottom: 2rem
    display: block
    @include respond-to(xs)
      display: none
  .header-logo
    display: none
    cursor: pointer
    @include respond-to(xs)
      display: flex
      width: 15rem
      height: 5rem
      align-items: center
      .vv-image
        width: 100%
        img
          width: 100%
  nav,
    button
      &:focus
        outline: none
    .menu-button
      padding: 1rem 0
      top: 6.4rem
      right: 10vW
      position: fixed
      display: block
      text-decoration: none
      z-index: 999999
      background-color: rgba(0, 0, 0, 0)
      border: none
      color: #FFF
      background-color: rgba(255,255,255,0)
      &:hover
        border-bottom: none
      &.white
        color: #000
      @include respond-to(xs)
        display: none
      &.active
        color: #000
        background-color: rgba(255,55,255,0)
      &.active.white
        color: #FFF
        background-color: rgba(255,255,255,0)
    a
      display: block
      padding: 0
      color: #000
      display: inline
      @include respond-to(md)
        &:hover
          border-bottom: solid 2px #000
      @include respond-to(lg)
        &:hover
          border-bottom: solid 2px #000
    .black
      background-color: #000
      a
        color: #FFF
        &:hover
          border-bottom: solid 2px #FFF
    // >h2
    //   background-color: rgba(255,55,255,0)
    //   display: block
    //   @include respond-to(xs)
    //     display: none
    //   &.active
    //     color: #000
    //     background-color: rgba(255,55,255,0)
    //   &.active.white
    //     color: #FFF
    //     background-color: rgba(255,255,255,0)
    >h2, >ul, >.icon, >.hamburger, .x
      position: fixed
      padding-left: 0
    >h2, .icon
      z-index: 999999
      cursor: pointer
      top: 6.4rem
      right: 10vW
    >.icon
      padding-top: 2.4rem
      right: 3.81vW
      @include respond-to(xs)
        padding: 0
        top: 0
        right: 3.81vW
        display: flex
        height: 5rem
        align-items: center
    >.hamburger, .x
      right: 9rem
      width: 4rem
      top: 0
      height: 5rem
      display: none
      @include respond-to(xs)
        display: flex
        align-items: center
        .vv-image
          width: 100%
          img
            width: 100%
    >.x
      width: 3rem
      right: 9rem
      z-index: 999999999
    >ul
      left: 66.6vW
      width: 34.4vW
      top: 0
      padding-top: 14rem
      overflow-y: auto
      height: calc(100% - 14rem)
      z-index: 99999
      @include transition(transform, 0.2s, ease-in-out)
      @include translateX(34vW)
      background-color: #FFF
      @include respond-to(xs)
        left: 35.4vW
        width: 65.6vW
        @include translateX(66vW)
        padding-top: 7rem
        height: calc(100% - 7rem)
      &.active
        @include translateX(0)
      >li
        padding: 0
        margin-left: $menuMargin
        // h4
        //   padding-left: 0
        a
          @include respond-to(xs)
            margin-left: 2rem
        // h3
        //   @include respond-to(xs)
        //     display: none
        .icon
          margin-top: 1.2rem
          .vv-image
            width: 100%
            margin-left: $menuMargin
    .search
      margin-left: $menuMargin
      font-size: 1.6rem
      .dn
        display: none
      input
        width: 28.95vW
        @include respond-to(xs)
          width: 61.55vW
          padding: 0
        font-size: 4rem
        font-weight: 700
        outline: 0
        border: none
        border-bottom: solid 2px
        border-radius: 0
        text-align: left
      h4
        font-size: 2rem
        line-height: 200%
        cursor: pointer
        color: #000
      &.black
        input[type='text']
          background-color: #000
          color: #FFF
        h4
          color: #FFF
  .banner
    height: 59px
    width: 100vw
    background-color: rgb(126, 132, 255)
    display: flex
    align-items: center
    @include respond-to(xs)
      height: 50px
    h2
      padding: 0
      width: 100vw
      text-align: center
      color: white
      font-weight: 300
      font-size: 24px
      line-height: 1
      display: block !important
      @include respond-to(xs)
        font-size: 16px
        width: 80vw
        margin: auto
        line-height: 1
      a
        text-decoration: underline
</style>



// WEBPACK FOOTER //
// TopNav.vue?7774382a